import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconToggleOn = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 71.9985302,
			d: "M935.337 512.003c0 147.613-119.832 267.455-267.445 267.455H356.128c-147.613 0-267.455-119.842-267.455-267.455s119.842-267.445 267.455-267.445h311.764c147.613 0 267.445 119.832 267.445 267.445"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7064.61,
			cy: 3017.29,
			r: 169.507,
			transform: "matrix(.9973 0 0 .9973 -6378.54 -2497.16)"
		})
	]
});
export default SvgIconToggleOn;
